var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            direction: _vm.direction,
            modal: true,
            size: _vm.formData.width,
            title: _vm.formData.title,
            visible: _vm.drawer,
            "wrapper-closable": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.fileData.id !== undefined
            ? _c(
                "div",
                { staticClass: "content" },
                [
                  _c("div", { staticClass: "logo" }, [
                    _c("i", {
                      staticClass: "icon iconfont",
                      class: _vm.getFileType(
                        _vm.fileData.type,
                        _vm.fileData.file_url
                      ),
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("file.detailedinformation"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "content-list mt15", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { staticClass: "content-left" }, [
                        _c("i", {
                          staticClass: "icon iconfont iconkuaizhuangyangshi",
                        }),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { staticClass: "content-right" }, [
                        _c("div", [_vm._v(_vm._s(_vm.$t("file.filetype")))]),
                        _vm._v(" "),
                        _vm.fileData.type !== 1
                          ? _c("div", [_vm._v(_vm._s(_vm.fileData.file_ext))])
                          : _c("div", [_vm._v(_vm._s(_vm.$t("file.folder")))]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.fileData.type !== 1
                    ? _c(
                        "el-row",
                        {
                          staticClass: "content-list mt15",
                          attrs: { gutter: 20 },
                        },
                        [
                          _c("el-col", { staticClass: "content-left" }, [
                            _c("i", {
                              staticClass:
                                "icon iconfont iconkuaizhuangyangshi",
                            }),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { staticClass: "content-right" }, [
                            _c("div", [_vm._v("文件大小")]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatBytesFn(_vm.fileData.file_size)
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "content-list", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { staticClass: "content-left" }, [
                        _c("i", {
                          staticClass: "icon iconfont iconwenjianweizhi",
                        }),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { staticClass: "content-right" }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("file.filelocation"))),
                        ]),
                        _vm._v(" "),
                        _vm.fileData.path.length > 0
                          ? _c("div", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("file.allpositions")) +
                                  "\n            "
                              ),
                              _c("span", [
                                _vm._v("/ " + _vm._s(_vm.fileData.path)),
                              ]),
                            ])
                          : _c("div", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("file.allpositions")) +
                                  "\n          "
                              ),
                            ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "content-list", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { staticClass: "content-left" }, [
                        _c("i", {
                          staticClass: "icon iconfont icongongxiangzu",
                        }),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { staticClass: "content-right" }, [
                        _c("div", [_vm._v(_vm._s(_vm.$t("hr.founder")))]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.fileData.user.name || "--")),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "content-list", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { staticClass: "content-left" }, [
                        _c("i", {
                          staticClass: "icon iconfont iconchuangjianshijian",
                        }),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { staticClass: "content-right" }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("file.creationtime"))),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.fileData.created_at))]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "content-list", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { staticClass: "content-left" }, [
                        _c("i", {
                          staticClass: "icon iconfont iconxiugaishijian",
                        }),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { staticClass: "content-right" }, [
                        _c("div", [_vm._v(_vm._s(_vm.$t("file.updatetime")))]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.fileData.updated_at))]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }